export default __webpack_public_path__ + "static/media/blue-course-background.d1f77b31.svg";